import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { ShoppingCart, User, Menu, X, Droplets } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

const NAV = [
  { label: "Home", to: "/" },
  { label: "Shop", to: "/shop" },
  { label: "Upcoming", to: "/upcoming" },
  { label: "About", to: "/about" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

export default function Header() {
  const { count } = useCart();
  const { user, isAdmin } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-md border-b border-slate-200/80" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 shrink-0" data-testid="logo-link">
            <span className="w-9 h-9 rounded-lg bg-navy flex items-center justify-center">
              <Droplets className="w-5 h-5 text-teal-500" />
            </span>
            <span className="font-heading font-extrabold text-navy text-base sm:text-lg leading-none">
              Water Business Guru
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-7">
            {NAV.map((n) => (
              <Link key={n.to} to={n.to} data-testid={`nav-${n.label.toLowerCase()}`}
                className="text-sm font-medium text-slate-600 hover:text-teal transition-colors">
                {n.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-1 sm:gap-2">
            {isAdmin && (
              <Button variant="ghost" size="sm" className="hidden sm:inline-flex" data-testid="admin-link"
                onClick={() => navigate("/admin")}>Admin</Button>
            )}
            <Link to="/cart" className="relative p-2" data-testid="cart-icon">
              <ShoppingCart className="w-5 h-5 text-navy" />
              {count > 0 && (
                <span className="absolute -top-0.5 -right-0.5 bg-teal text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1" data-testid="cart-count">
                  {count}
                </span>
              )}
            </Link>
            <Link to={user ? "/account" : "/login"} className="p-2 hidden md:block" data-testid="account-icon">
              <User className="w-5 h-5 text-navy" />
            </Link>
            <button className="md:hidden p-2" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
              {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white" data-testid="mobile-menu">
          <div className="px-4 py-2 flex flex-col">
            {NAV.map((n) => (
              <Link key={n.to} to={n.to} onClick={() => setOpen(false)}
                className="py-3 text-sm font-medium text-slate-700 border-b border-slate-100">
                {n.label}
              </Link>
            ))}
            {isAdmin && <Link to="/admin" onClick={() => setOpen(false)} className="py-3 text-sm font-semibold text-teal">Admin Panel</Link>}
            <Link to={user ? "/account" : "/login"} onClick={() => setOpen(false)} className="py-3 text-sm font-medium text-slate-700">
              {user ? "My Account" : "Login / Register"}
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
